import { invoicing } from "../../constants/apis/apiEndpoints";
import axiosInstance from "../../translator";

export const generateInvoiceApi = async (data) => {
  return axiosInstance
    .post(`${invoicing?.generateInvoice}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
export const getInvoiceListApi = async (urlParams) => {
  return axiosInstance
    .get(`${invoicing?.generateInvoice}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const uploadInvoiceJsonApi = async (data) => {
  return axiosInstance
    .post(`${invoicing?.uploadInvoiceTemplate}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
export const updatePaymentStatusApi = async (invoiceId, data) => {
  return axiosInstance
    .patch(`${invoicing?.generateInvoice}/${invoiceId}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
